import sample_1 from './jeans_1.jpg';
import sample_2 from './jeans_2.jpg';

export const braxJeansImpressions = {
    sample_1,
    sample_2
};
